"use client";

import { Dispatch, SetStateAction } from "react";
import ReCAPTCHA from "react-google-recaptcha";

type TProps = {
  showCaptchaError: boolean;
  setCaptchaVerified: Dispatch<SetStateAction<string | null>>;
  setShowCaptchaError: Dispatch<SetStateAction<boolean>>;
};

const RecaptchaComponent = ({
  showCaptchaError,
  setCaptchaVerified,
  setShowCaptchaError,
}: TProps) => {
  const handleChange = (value: string | null) => {
    setCaptchaVerified(value);
    setShowCaptchaError(false);
  };

  return (
    <div>
      <ReCAPTCHA
        sitekey={process.env.NEXT_PUBLIC_SITE_KEY as string}
        onChange={handleChange}
      />

      {showCaptchaError && (
        <p className="mt-1.5 text-[14px] font-semibold text-red-500">
          Please Fill in the reCAPTCHA
        </p>
      )}
    </div>
  );
};

export default RecaptchaComponent;
